export enum TranslateStep {
  select = "select",
  translate = "translate",
}
